import { AutogenModelTransferToSettlementPayee, AutogenRowTransferToSettlementPayee } from "./autogen/AutogenModelTransferToSettlementPayee";

export class ModelTransferToSettlementPayee extends AutogenModelTransferToSettlementPayee<RowTransferToSettlementPayee> {
	constructor() {
		super(RowTransferToSettlementPayee);
	}
}

export class RowTransferToSettlementPayee extends AutogenRowTransferToSettlementPayee {
}